export default __webpack_public_path__ + "static/media/us_4.0e0656c0.mp3";